import { render, staticRenderFns } from "./BreadcrumbV2.vue?vue&type=template&id=6ff2a770&scoped=true&"
import script from "./BreadcrumbV2.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbV2.vue?vue&type=script&lang=js&"
import style0 from "./BreadcrumbV2.vue?vue&type=style&index=0&id=6ff2a770&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff2a770",
  null
  
)

export default component.exports